import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializationService {
  private readonly _authService = inject(AuthService);
  public async initializeApp(): Promise<void> {
    this._authService.isLoggedIn.set(this._authService.isValidToken());
  }
}